/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography } from '@coursera/cds-core';

import _t from 'i18n!nls/partners-graphql';

const InstructorProfileNotFound = () => {
  return (
    <Grid container className="rc-InstructorProfileNotFound max-width-980 m-y-3">
      <Grid item xs={12}>
        <Typography component="h2" variant="h2">
          {_t('The instructor profile could not be found.')}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default InstructorProfileNotFound;
